<template>
    <div class="main-div">
        <div class="header">
            <div class="title-div">
                <div class="badge-div">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M18.4999 14.6945L11.6678 2.82968C11.4971 2.53899 11.2534 2.29797 10.9608 2.13051C10.6682 1.96304 10.337 1.87494 9.99986 1.87494C9.66275 1.87494 9.33149 1.96304 9.03892 2.13051C8.74635 2.29797 8.50262 2.53899 8.33189 2.82968L1.49986 14.6945C1.33559 14.9757 1.24902 15.2955 1.24902 15.6211C1.24902 15.9467 1.33559 16.2665 1.49986 16.5476C1.6684 16.8401 1.91171 17.0824 2.20483 17.2498C2.49795 17.4171 2.83032 17.5035 3.16783 17.5H16.8319C17.1691 17.5032 17.5012 17.4167 17.794 17.2494C18.0868 17.082 18.3299 16.8399 18.4983 16.5476C18.6628 16.2666 18.7496 15.9469 18.7499 15.6213C18.7502 15.2957 18.6639 14.9758 18.4999 14.6945ZM9.37486 8.12499C9.37486 7.95923 9.44071 7.80026 9.55792 7.68305C9.67513 7.56584 9.8341 7.49999 9.99986 7.49999C10.1656 7.49999 10.3246 7.56584 10.4418 7.68305C10.559 7.80026 10.6249 7.95923 10.6249 8.12499V11.25C10.6249 11.4158 10.559 11.5747 10.4418 11.6919C10.3246 11.8091 10.1656 11.875 9.99986 11.875C9.8341 11.875 9.67513 11.8091 9.55792 11.6919C9.44071 11.5747 9.37486 11.4158 9.37486 11.25V8.12499ZM9.99986 15C9.81444 15 9.63319 14.945 9.47901 14.842C9.32484 14.739 9.20468 14.5926 9.13372 14.4213C9.06277 14.2499 9.0442 14.0615 9.08038 13.8796C9.11655 13.6977 9.20584 13.5307 9.33695 13.3996C9.46806 13.2685 9.63511 13.1792 9.81696 13.143C9.99882 13.1068 10.1873 13.1254 10.3586 13.1964C10.5299 13.2673 10.6763 13.3875 10.7794 13.5416C10.8824 13.6958 10.9374 13.8771 10.9374 14.0625C10.9374 14.3111 10.8386 14.5496 10.6628 14.7254C10.487 14.9012 10.2485 15 9.99986 15Z"
                            fill="currentColor"
                        />
                    </svg>
                    <span>{{ advisoryTypeLabel(props.advisory.type) }}</span>
                </div>
                <div class="timed-div">{{ formatDatePattern(props.advisory.created_at, 'MMMM Do, YYYY') || 'N/A' }}</div>
            </div>
            <PrimeTag>
                {{ props.advisory.id }}
            </PrimeTag>
        </div>
        <div class="divider"></div>
        <div class="desc-div">
            <div>
                <a :href="props.advisory.url" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">
                    {{ props.advisory.url }}
                </a>
            </div>
        </div>
        <div class="divider block lg:hidden"></div>
        <div class="footer-div">
            <div 
                class="more-div" 
                @click="emit('handleShowSpecificIncident', props.advisory.id)"
                @keydown="(event: KeyboardEvent) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        emit('handleShowSpecificIncident', props.advisory.id);
                    }
                }"
                :tabindex="0"
                role="button"
                aria-label="Read more about this advisory"
            >
                <span>Read More</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M17.3172 10.4422L11.6922 16.0672C11.5749 16.1844 11.4159 16.2503 11.25 16.2503C11.0841 16.2503 10.9251 16.1844 10.8078 16.0672C10.6905 15.9499 10.6247 15.7908 10.6247 15.625C10.6247 15.4591 10.6905 15.3001 10.8078 15.1828L15.3664 10.625H3.125C2.95924 10.625 2.80027 10.5591 2.68306 10.4419C2.56585 10.3247 2.5 10.1657 2.5 9.99998C2.5 9.83422 2.56585 9.67525 2.68306 9.55804C2.80027 9.44083 2.95924 9.37498 3.125 9.37498H15.3664L10.8078 4.81717C10.6905 4.69989 10.6247 4.54083 10.6247 4.37498C10.6247 4.20913 10.6905 4.05007 10.8078 3.93279C10.9251 3.81552 11.0841 3.74963 11.25 3.74963C11.4159 3.74963 11.5749 3.81552 11.6922 3.93279L17.3172 9.55779C17.3753 9.61584 17.4214 9.68477 17.4529 9.76064C17.4843 9.83652 17.5005 9.91785 17.5005 9.99998C17.5005 10.0821 17.4843 10.1634 17.4529 10.2393C17.4214 10.3152 17.3753 10.3841 17.3172 10.4422Z"
                        fill="currentColor"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { advisoryTypeLabel } from '~/utils/advisory-display';
import { formatDatePattern } from '@privacy-bee/format/date';

const props = defineProps({
    advisory: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['handleShowSpecificIncident']);
</script>
<style lang="scss" scoped>
.main-div {
    @apply flex flex-col items-start self-stretch py-5 px-6 gap-4 rounded-lg border border-gray-200 bg-white shadow-sm;
}
.header {
    @apply flex sm:flex-row flex-col items-center self-stretch gap-2 py-1;
}
.title-div {
    @apply justify-between flex items-center gap-2 flex-1;
}
.badge-div {
    @apply flex items-center gap-2.5 px-1.5 py-0.5 pl-1;
    color: var(--danger-mark);

    span {
        @apply text-center text-sm font-medium leading-5 text-red-500;
    }
}
.timed-div {
    @apply hidden lg:block text-right text-xs font-normal leading-5 text-zinc-500;
}
.pb-num {
    @apply flex items-center px-1.5 py-0.5 rounded border border-zinc-300 bg-white shadow-sm;

    span {
        @apply text-zinc-700 text-center text-xs font-medium leading-5;
    }
}
.divider {
    @apply h-px flex-shrink-0 self-stretch bg-gray-200;
}
.desc-div {
    @apply self-stretch text-zinc-950 text-sm font-normal leading-6;
}
.footer-div {
    @apply flex justify-end items-center flex-1 self-stretch;
}
.more-div {
    @apply flex justify-center items-center gap-2 cursor-pointer;
    color: var(--action);

    span {
        @apply text-blue-600 text-sm font-semibold leading-5;
    }
}
</style>
